import { z } from 'zod';
import { uuidSchema } from '../const/uuidSchema';

const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

const optTextNullable = z
    .string()
    .trim()
    .max(8000, 'не больше 8000 символов')
    .nullable()
    .optional();

const optShortNullable = z
    .string()
    .trim()
    .max(500, 'не больше 500 символов')
    .nullable()
    .optional();

const keywordsNullable = z.array(z.string().trim().min(1).max(100)).max(50).nullable().optional();

export const selectionListInputSchema = z.object({
    id: uuidSchema.optional(),

    // legacy / RU
    title: z
        .string({ required_error: 'укажите название (RU)', invalid_type_error: 'строка' })
        .trim()
        .min(1, 'введите название')
        .max(300, 'не больше 300 символов'),

    titleEn: z.string().trim().max(300).default(''),
    titleKa: z.string().trim().max(300).default(''),

    slug: z
        .string({ required_error: 'укажите slug', invalid_type_error: 'строка' })
        .trim()
        .min(1, 'введите slug')
        .max(120, 'не больше 120 символов')
        .regex(SLUG_REGEX, 'только латиница, цифры и дефисы (без -- и без дефиса в начале/конце)'),

    description: optTextNullable,
    descriptionEn: optTextNullable,
    descriptionKa: optTextNullable,

    isActive: z.boolean().default(true),
    bookmark: z.boolean().default(false),

    imageId: uuidSchema.nullable().optional(),

    // SEO — RU (legacy)
    metadataTitle: optShortNullable,
    metadataDescription: optTextNullable,
    metadataKeywords: keywordsNullable,
    metadataPageDescription: optTextNullable,

    // SEO — EN
    metadataTitleEn: optShortNullable,
    metadataDescriptionEn: optTextNullable,
    metadataKeywordsEn: keywordsNullable,
    metadataPageDescriptionEn: optTextNullable,

    // SEO — KA
    metadataTitleKa: optShortNullable,
    metadataDescriptionKa: optTextNullable,
    metadataKeywordsKa: keywordsNullable,
    metadataPageDescriptionKa: optTextNullable,
});

export type SelectionListInputSchema = z.infer<typeof selectionListInputSchema>;
